import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import ddt from '@wix/da-ddt';
import { getInfoToDisplayImageDeviation } from '../../../../DeviationViews/Dumbo/Image/_helpers';
import Unknown from '../Unknown';
import { isValidFileSrc } from '../../../../DeviationViews/_helpers';
import { getThumbGlobalClassNames } from '../../helpers';
/**
 *
 * IMPORTANT!
 * Currently to support green/mobile we are using inline
 * styles to render editor related content. Do NOT add
 * classes to anything here for now.
 */
var ImageDumbView = function (props) {
    var deviation = props.deviation, propsWidth = props.width, propsHeight = props.height, propsUseCoverMode = props.useCoverMode, // forced via props
    allowPreviewUsage = props.allowPreviewUsage;
    if (!propsWidth && !propsHeight) {
        // no use-cases for responsive image views
        ddt.warn('deviationviews', 'Deviation image is not rendered because of missing Width and Height properties');
        return React.createElement(Unknown, __assign({}, props));
    }
    var info = getInfoToDisplayImageDeviation({
        deviation: deviation,
        height: propsHeight,
        width: propsWidth,
        allowPreviewUsage: allowPreviewUsage,
    });
    if (!info ||
        !info.pickedImage ||
        !info.pickedImage.src ||
        !isValidFileSrc(info.pickedImage.src)) {
        ddt.warn('deviationviews', 'Could not find a suitable image file to render deviation image', info);
        return React.createElement(Unknown, __assign({}, props));
    }
    var height = info.height, width = info.width, wrapperStyles = info.wrapperStyles, pickedImage = info.pickedImage, bestFitCoverMode = info.useCoverMode;
    var imgStyles = info.imgStyles;
    // Gifs need special casing, there can be situation where
    // the gif file is HUGE we check the filesize for sanity
    if (pickedImage.type === 'gif' && (pickedImage.filesize || 0) > 300000) {
        ddt.log('deviationviews', 'Ignoring large GIF file - not suitable for thumbs', pickedImage);
        return React.createElement(Unknown, __assign({}, props));
    }
    var useCoverMode = bestFitCoverMode || propsUseCoverMode;
    var wrapStyles = __assign({ width: width,
        height: height }, wrapperStyles);
    imgStyles = __assign(__assign({}, imgStyles), { flexGrow: 0, flexShrink: 0 });
    if (useCoverMode) {
        imgStyles.display = 'none';
        wrapStyles.backgroundImage = "url(\"" + pickedImage.src + "\")";
        wrapStyles.backgroundRepeat = 'no-repeat';
        wrapStyles.backgroundPosition = 'center';
    }
    return (React.createElement("div", { className: classnames('daeditor-thumb-image', getThumbGlobalClassNames(deviation)), style: __assign(__assign({}, wrapStyles), { display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }) },
        React.createElement("img", { src: pickedImage.src, alt: deviation.title, style: imgStyles })));
};
ImageDumbView.displayName = 'ImageDumbView';
export default ImageDumbView;
//# sourceMappingURL=ImageHtml.js.map